import React from 'react';
import styled from 'styled-components';

import {
  RESMIO_LEGAL_NOTICE_URL,
  RESMIO_PRIVACY_POLICY_URL,
  RESMIO_TERMS_CONDITIONS_URL,
} from 'app/constants';
import cookieConsentStore from 'app/components/cookieConsent/store';

const Container = styled.div`
  padding: 2rem;
  text-align: center;

  > ul {
    list-style-type: none;
    margin: 0;
    padding: 0;

    > li {
      display: inline;

      &:not(:last-child)::after {
        content: ' | ';
      }
    }
  }
`;

function LegalFooter() {
  return (
    <Container>
      <div>© {new Date().getFullYear()} resmio GmbH</div>
      <ul>
        <li>
          <a href={RESMIO_TERMS_CONDITIONS_URL} target="_blank">
            {i18n.gettext('Terms & Conditions')}
          </a>
        </li>
        <li>
          <a href={RESMIO_PRIVACY_POLICY_URL} target="_blank">
            {i18n.gettext('Privacy policy')}
          </a>
        </li>
        <li>
          <a href={RESMIO_LEGAL_NOTICE_URL} target="_blank">
            {i18n.gettext('Legal notice')}
          </a>
        </li>
        <li>
          <a href="#" onClick={cookieConsentStore.openConsent}>
            {i18n.gettext('Cookie settings')}
          </a>
        </li>
      </ul>
    </Container>
  );
}

export default LegalFooter;
